// extracted by mini-css-extract-plugin
export default {"background":"goe4OI4VNBWkGQUa7BAJ","spin":"PG7hTgNBqFKK0wAkgMjG","content":"Z2pEPiP3OxM8cge66ZW3"};